import { Injectable } from '@angular/core';
import { FonteDadosService } from './fonte-dados.service';
import { FonteDados } from './fonte-dados.model';
import { publish, refCount, first } from 'rxjs/operators';
import { from, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MonitoramentoCacheService {

  cacheConversor = {};
  cacheExtrator = {};
  cachePrisma = {};
  cacheIris = {};

  constructor(private service: FonteDadosService) { }


  getConversor(fonteDados: FonteDados, limparCache: boolean = false): Observable<any> {
    if (limparCache) {
      this.cacheConversor[fonteDados.id] = this.fetchConversor(fonteDados);
    }
    else {
      this.cacheConversor[fonteDados.id] = this.cacheConversor[fonteDados.id] || this.fetchConversor(fonteDados);
    }
    return this.cacheConversor[fonteDados.id];
  }

  getExtrator(fonteDados: FonteDados, limparCache: boolean = false): Observable<any> {
    if (limparCache) {
      this.cacheExtrator[fonteDados.id] = this.fetchExtrator(fonteDados);
    }
    else {
      this.cacheExtrator[fonteDados.id] = this.cacheExtrator[fonteDados.id] || this.fetchExtrator(fonteDados);
    }
    return this.cacheExtrator[fonteDados.id];
  }

  getPrisma(fonteDados: FonteDados, limparCache: boolean = false): Observable<any> {
    if (limparCache) {
      this.cachePrisma[fonteDados.id] = this.fetchPrisma(fonteDados);
    }
    else {
      this.cachePrisma[fonteDados.id] = this.cachePrisma[fonteDados.id] || this.fetchPrisma(fonteDados);
    }
    return this.cachePrisma[fonteDados.id];
  }

  getIris(fonteDados: FonteDados, limparCache: boolean = false): Observable<any> {
    if (limparCache) {
      this.cacheIris[fonteDados.id] = this.fetchIris(fonteDados);
    }
    else {
      this.cacheIris[fonteDados.id] = this.cacheIris[fonteDados.id] || this.fetchIris(fonteDados);
    }
    return this.cacheIris[fonteDados.id];
  }

  fetchConversor(fonteDados: FonteDados) {
    return from(this.service.monitorarConversor(fonteDados)).pipe(
      publish(),
      refCount(),
      first()
    );
  }

  fetchExtrator(fonteDados: FonteDados) {
    return from(this.service.monitorarExtrator(fonteDados)).pipe(
      publish(),
      refCount(),
      first()
    );
  }

  fetchPrisma(fonteDados: FonteDados) {
    return from(this.service.monitorarPrisma(fonteDados)).pipe(
      publish(),
      refCount(),
      first()
    );
  }

  fetchIris(fonteDados: FonteDados) {
    return from(this.service.monitorarIris(fonteDados)).pipe(
      publish(),
      refCount(),
      first()
    );
  }

}
